// ------------------------------------
// Import SCSS files
// ------------------------------------
import "../sass/single-expertises.scss";

// ------------------------------------
// Scripts
// ------------------------------------